interface MenuItem {
   label: string;
   path: string;
}

export const headerMenuItems: MenuItem[] = [
   { label: "About Us", path: "/about-us" },
   { label: "Blog", path: "/blog" },
   { label: "FAQ", path: "/faq" },
   { label: "Pricing", path: "/cms/pricing" },
   { label: "Contact Us", path: "/contact-us" },
];

export const authHeaderMenuItems: MenuItem[] = [
   { label: "About Us", path: "https://tracnest.com/about" },
   { label: "Blog", path: "https://tracnest.com/blog" },
   { label: "FAQ", path: "https://tracnest.com/faq" },
   { label: "Pricing", path: "https://tracnest.com/pricing" },
   { label: "Contact Us", path: "https://tracnest.com/contact-us" },
];

export const authFooterMenuItems: MenuItem[] = [
   { label: "About Us", path: "https://tracnest.com/about" },
   { label: "Blog", path: "https://tracnest.com/blog" },
   { label: "FAQ", path: "https://tracnest.com/faq" },
   { label: "Contact Us", path: "https://tracnest.com/contact-us" },
];

export const mainFooterMenuItems: MenuItem[] = [
   { label: "Home", path: "https://tracnest.com" },
   { label: "About Us", path: "https://tracnest.com/about" },
   { label: "Blog", path: "https://tracnest.com/blog" },
   { label: "FAQ", path: "https://tracnest.com/faq" },
   { label: "Contact Us", path: "https://tracnest.com/contact-us" },
];

export const MAIN_MENU = [
   { id: 1, name: 'Home', path: '/' },
   { id: 2, name: 'About Us', path: '/about-us' },
   { id: 3, name: 'Become a Member', path: '/become-a-member' },
   { id: 4, name: 'Sponsorship', path: '/sponsorship' },
   { id: 5, name: 'Gallery', path: '/gallery' },
   { id: 6, name: 'Forums', path: '/forums' },
   { id: 7, name: 'Contact Us', path: '/contact' },
]
export interface INTERFACE_MENU {
   id: number;
   name: string;
   path: string;
}